import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const systems = [
  "Split Air Conditioning Systems",
  "Centralized HVAC Systems",
  "VRF / VRV Systems",
  "Packaged Air Conditioning Units",
  "Chiller-Based Cooling Systems"
];

const SystemsWeService = () => {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-20">
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:w-1/2"
          >
            <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-8">Systems We Service</h2>
            <h3 className="text-4xl md:text-5xl font-bold text-[#4D4C4A] leading-tight mb-8 italic tracking-tighter">
              Versatility in <span className="text-[#91756A]">Cooling</span> Solutions.
            </h3>
            <p className="text-slate-500 text-lg leading-relaxed mb-12">
              Our engineers maintain a wide range of air conditioning systems used in residential and commercial 
              buildings, ensuring optimal performance regardless of complexity.
            </p>
            
            <div className="space-y-4">
              {systems.map((system, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.5 }}
                  className="flex items-center gap-4 group"
                >
                  <div className="w-10 h-10 bg-slate-50 flex items-center justify-center group-hover:bg-[#91756A] transition-colors duration-300">
                    <Icon name="Check" size={18} className="text-[#91756A] group-hover:text-white" />
                  </div>
                  <span className="text-[#4D4C4A] font-bold italic uppercase tracking-tight text-lg">{system}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="lg:w-1/2 relative aspect-square"
          >
            <div className="absolute inset-0">
              <Image 
                src="/assets/images/AC-page/AC-1080px-by-1080px-4.jpg" 
                alt="Systems We Service" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-[#4D4C4A]/30"></div>
            </div>
            <div className="absolute bottom-12 left-12 right-12">
              <span className="block text-6xl font-bold text-white opacity-90 italic uppercase">HVAC</span>
              <span className="block text-2xl font-bold text-white opacity-80 italic uppercase tracking-widest">Excellence</span>
            </div>

          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SystemsWeService;